import { render, staticRenderFns } from "./colorDialog.vue?vue&type=template&id=7a386542&"
import script from "./colorDialog.vue?vue&type=script&lang=js&"
export * from "./colorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports